var crate_tabs = ( function( $ ) {

	var $tabs;

	var _init = function() {
		$tabs = $( '.crate-tabs' );

		if ( $tabs.length > 0 ) {
			$tabs.find( '.crate-tab' ).on( 'click', _switch_tab );
		}
	};

	var _switch_tab = function( e ) {
		e.preventDefault();

		var tab = $( this ).data( 'tab' );

		$( '.crate-tab' ).removeClass( 'active' );
		$( '.crate-tab-content' ).removeClass( 'active' );

		$( this ).addClass( 'active' );
		$( '#crate-tab-' + tab ).addClass( 'active' );
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = crate_tabs;